import {
  recognizedAppDtoSchema,
  recognizedAppListDtoSchema,
  seenAppListDtoSchema,
  staffConnectionListDtoSchema,
  type RecognizedAppDto,
  type RecognizedAppListDto,
  type SeenAppListDto,
  type StaffConnectionListDto,
} from '@lib/dto/mcp.dto'
import type { AddRecognizedAppInput } from '@lib/input/mcp.input'
import type { Uuid } from '@lib/validators/params'
import { api, type ApiClient } from '@/helpers/apiClient'
import type { IOpsMcpService } from '@/types/OpsMcpService.types'

/**
 * MCP on the ops console (`McpOpsController`): staff connections (Support
 * see their own, admins everyone's) and the recognized apps admins manage.
 */
export class OpsMcpService implements IOpsMcpService {
  constructor(private readonly client: ApiClient) {}

  connections(): Promise<StaffConnectionListDto> {
    return this.client.get('/ops/mcp/connections', staffConnectionListDtoSchema)
  }

  disconnect(connectionId: Uuid): Promise<void> {
    return this.client.del(`/ops/mcp/connections/${encodeURIComponent(connectionId)}`)
  }

  seenApps(): Promise<SeenAppListDto> {
    return this.client.get('/ops/mcp/apps', seenAppListDtoSchema)
  }

  recognizedApps(): Promise<RecognizedAppListDto> {
    return this.client.get('/ops/mcp/recognized-apps', recognizedAppListDtoSchema)
  }

  addRecognizedApp(input: AddRecognizedAppInput): Promise<RecognizedAppDto> {
    return this.client.post('/ops/mcp/recognized-apps', input, recognizedAppDtoSchema)
  }

  removeRecognizedApp(appId: Uuid): Promise<void> {
    return this.client.del(`/ops/mcp/recognized-apps/${encodeURIComponent(appId)}`)
  }
}

export const opsMcpService = new OpsMcpService(api)
